import { InjectionToken } from '@angular/core';

export interface HelpDropdownConfig {
  userId: string;
}

export const HELP_DROPDOWN_CONFIG = new InjectionToken<HelpDropdownConfig>('HELP_DROPDOWN_CONFIG');

export function provideHelpDropdownConfig(config: HelpDropdownConfig) {
  return { provide: HELP_DROPDOWN_CONFIG, useValue: config };
}
